import gql from 'graphql-tag'
import { all, call, put, takeLatest } from 'redux-saga/effects'

import { actions, types } from '../reducers/logo'
import { getCurrentClubId } from './network'
import { apolloClient } from '@fe/business/src/apollo'

import { actions as clubActions } from '../reducers/clubs'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

const UPLOAD_CLUB_LOGO_ROUND_MUTATION = gql`
  mutation UploadClubLogoRound($input: UploadClubLogoInput!) {
    ClubMutation {
      uploadClubLogoRound(input: $input) {
        id
      }
    }
  }
`

const UPLOAD_CLUB_LOGO_RECTANGULAR_MUTATION = gql`
  mutation UploadClubLogoRectangular($input: UploadClubLogoInput!) {
    ClubMutation {
      uploadClubLogoRectangular(input: $input) {
        id
      }
    }
  }
`

// ImageUpload's cropper hands back a bare base64 PNG string (no data URI prefix) -
// convert it to a Blob so it can be sent as a real multipart Upload variable
const base64ToBlob = (base64, contentType = 'image/png') => {
  const byteCharacters = atob(base64)
  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  return new Blob([new Uint8Array(byteNumbers)], { type: contentType })
}

export function * saveRoundLogoEffect ({ data }) {
  try {
    const clubId = yield call(getCurrentClubId)
    yield call([apolloClient, apolloClient.mutate], {
      mutation: UPLOAD_CLUB_LOGO_ROUND_MUTATION,
      variables: { input: { clubId, image: base64ToBlob(data) } }
    })
    return {}
  } catch (error) {
    return { error }
  }
}

export function * saveRectangularLogoEffect ({ data }) {
  try {
    const clubId = yield call(getCurrentClubId)
    yield call([apolloClient, apolloClient.mutate], {
      mutation: UPLOAD_CLUB_LOGO_RECTANGULAR_MUTATION,
      variables: { input: { clubId, image: base64ToBlob(data) } }
    })
    return {}
  } catch (error) {
    return { error }
  }
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

export function * saveLogoFlow ({ payload }) {
  const { clubId, roundData, rectangularData } = payload

  if (roundData) {
    yield call(saveRoundLogoEffect, { data: roundData })
  } else if (rectangularData) {
    yield call(saveRectangularLogoEffect, { data: rectangularData })
  }

  yield put(clubActions.loadRequestSingle({ clubId }))
  yield put(actions.saveLogoDone())
  yield put(clubActions.dialogUploadHide())
}

export default function * () {
  return yield all([
    takeLatest(types.SAVE_LOGO, saveLogoFlow)
  ])
}
